import { VList } from 'vuetify/lib/components/VList';
import { VListItem } from 'vuetify/lib/components/VList';
import { VMenu } from 'vuetify/lib/components/VMenu';

var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c("div", [_c(VMenu, {
    staticClass: "menu",
    attrs: {
      absolute: "",
      "position-x": _vm.position.x,
      "position-y": _vm.position.y
    },
    model: {
      value: _vm.isOpen,
      callback: function callback($$v) {
        _vm.isOpen = $$v;
      },
      expression: "isOpen"
    }
  }, [_c(VList, _vm._l(_vm.items, function (item, index) {
    return _c(VListItem, {
      key: index
    }, [item.type === "routerLink" ? _c("router-link", {
      class: item.class,
      attrs: {
        to: item.routeData
      }
    }, [_c(VListItem, [_vm._v(_vm._s(item.text))])], 1) : item.type === "routerLinkBlank" ? _c("router-link", {
      class: item.class,
      attrs: {
        to: item.routeData,
        target: "_blank"
      }
    }, [_c(VListItem, [_vm._v(_vm._s(item.text))])], 1) : _vm._e()], 1);
  }), 1)], 1)], 1);
};
var staticRenderFns = [];
render._withStripped = true;
export { render, staticRenderFns };